import { useMutation, useQueryClient } from "@tanstack/react-query";
import { PortfolioKeys } from "web_myplann/Api/Portfolio/portfolioKeys";
import {
	type ClientPortfolioInvestmentEditRequestDTO,
	type PortfolioDetailResponseDTO,
	patchPortfolioInvestmentIdV2,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const usePatchPortfolioInvestmentMutation = (id: number) => {
	const queryClient = useQueryClient();

	return useMutation<
		PortfolioDetailResponseDTO,
		Error,
		Partial<ClientPortfolioInvestmentEditRequestDTO>
	>({
		mutationFn: processResponse((requestContract) =>
			patchPortfolioInvestmentIdV2(requestContract, id),
		),
		onSuccess: (data) => {
			queryClient.invalidateQueries({
				queryKey: PortfolioKeys.portfolioList(),
			});
			queryClient.setQueryData(PortfolioKeys.portfolioDetail(id), data);
		},
	});
};
